import { NgModule } from '@angular/core';
import { ProductRoutingModule } from './product-routing.module';
import { ProductlistComponent } from './productlist.component';
import { AddproductComponent } from '../addproduct/addproduct.component';
import { EditproductComponent } from '../editproduct/editproduct.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [
    ProductlistComponent,
    AddproductComponent,
    EditproductComponent
  ],
  imports: [
    ProductRoutingModule,
    SharedModule
  ]
})
export class ProductModule {}
